<template>
  <ClientOnly>
    <CountUp
      :end-val="endVal"
      :start-val="startVal"
      :duration="duration"
      :decimal-places="decimalPlaces"
      :autoplay="autoplay"
      :loop="loop"
      :delay="delay"
      :options="options"
      class="inline-block"
      :class="customClass"
    />
  </ClientOnly>
</template>

<script setup lang="ts">
import CountUp, { type CountUpOptions } from 'vue-countup-v3'

// Define props with default values
withDefaults(
  defineProps<{
    endVal: number
    startVal?: number
    duration?: number
    decimalPlaces?: number
    autoplay?: boolean
    loop?: boolean | number
    delay?: number
    customClass?: string
    options?: CountUpOptions
  }>(),
  {
    startVal: 0,
    duration: 2.5,
    decimalPlaces: 0,
    autoplay: true,
    loop: false,
    delay: 0,
    customClass: '',
    options: () => ({}),
  },
)
</script>
